// extracted by mini-css-extract-plugin
export default {"textincircle_container":"gMLUieVQ6yR7Gc4s1RBZ"};